import React, { createContext, useState, useEffect } from 'react';
const getlocalStorageItem = () => {
  let userId = localStorage.getItem("PCX_STORE_admin_ID");
  if (userId) {
    return JSON.parse(userId);
  } else {
    return null;
  }

}


  function getCookie(name) {
    const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return cookieValue ? cookieValue.pop() : '';
  }


export const AuthContext = createContext('');

const AuthProvider = ({ children }) => {
  const [authId, setAuthId] = useState(getlocalStorageItem());
  const [authUser, setAuthUser] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [token, setToken] = useState(getCookie('PCX_STORE_admin_token'));
  const LoginWithEmail = (data) => {
    setAuthId(data);
    // console.log("context api : ", data);
  }



  useEffect(() => {
    if (authId?._id) {
      fetch(`https://api.wlffinance.org/api/admin/role/view/${authId?._id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.success) {
            setAuthUser(data?.data);
          } else {
            SignOut();
          }
          setLoading(false);
        });
    } else {
      SignOut();
      setLoading(false);
      return;
    }
  }, [authId]);


  const SignOut = () => {
    document.cookie = `PCX_STORE_admin_token=; expires=${new Date(
      0
    ).toUTCString()};  path=/admin`;
    document.cookie = `PCX_STORE_admin_token=; expires=${new Date(
      0
    ).toUTCString()};  path=/`;
    localStorage.removeItem("PCX_STORE_admin_ID");
    const data = null;
    LoginWithEmail(data);
  };


  const authInfo = { authUser, LoginWithEmail, isLoading, setLoading, setAuthUser, token, authId };
  if (isLoading) {
    return;
  }
  return (
    <AuthContext.Provider value={authInfo}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;